var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "20px",
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pause",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,19.3645833 L5,0.630208333 C5,0.28125 4.71875,0 4.36458333,0 L0.635416667,0 C0.28125,0 0,0.28125 0,0.630208333 L0,19.3645833 C0,19.7135417 0.28125,20 0.635416667,20 L4.36458333,20 C4.71875,20 5,19.71875 5,19.3645833 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6979167,0 L8.96875,0 C8.61979167,0 8.33333333,0.28125 8.33333333,0.630208333 L8.33333333,19.3645833 C8.33333333,19.7135417 8.61458333,20 8.96875,20 L12.6979167,20 C13.046875,20 13.3333333,19.71875 13.3333333,19.3645833 L13.3333333,0.630208333 C13.3333333,0.28125 13.0520833,0 12.6979167,0 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.68b9c3700101e8326dcb8b5dd2ed61ea.svg";
export { ForwardRef as ReactComponent };